import { Action } from '../../types/actions';
import { FeatureFlagMap, FeatureFlagsEnum } from '../../types/working-model';
import { SET_FEATURE_FLAGS, TOGGLE_FEATURE_FLAG } from '../actions/feature-flags';

const isProd = process.env.REACT_APP_STAGE === 'prod';
const isHot = process.env.REACT_APP_STAGE === 'hotfix';

export interface IFeatureFlagsReducer {
	featureFlags: FeatureFlagMap;
}

const initialState: IFeatureFlagsReducer = {
	featureFlags: {}
};

export default function FeatureFlagsReducer(state = initialState, action: Action): IFeatureFlagsReducer {
	switch (action.type) {
		case SET_FEATURE_FLAGS: {
			return {
				...state,
				featureFlags: action.payload
			};
		}
		case TOGGLE_FEATURE_FLAG: {
			// do not allow this reducer to do anything in production.
			if (isProd || isHot) {
				return state;
			}

			return {
				...state,
				featureFlags: {
					...state.featureFlags,
					[action.payload as FeatureFlagsEnum]: !state.featureFlags[action.payload as FeatureFlagsEnum]
				}
			};
		}
		default: return state;
	}
}